(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UsersPerVisitReportViewModel', usersPerVisitReportViewModelFactory);

  /** @ngInject */
  function usersPerVisitReportViewModelFactory($translate, reportActions, reportsFilterStore, dispatcher, ActionTypesEnum) {
    function UsersPerVisitReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'category',
          label: {
              text: '(' + $translate.instant('TOTAL_USERS_BY_GROUP_VISITS_UNIT') + ')',
              position: 'outer-right'
          }
        }
      };

      this.chartType = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';

      init.call(this);
    }

    UsersPerVisitReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return UsersPerVisitReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions.getUsersPerVisitCount(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.unit = $translate.instant('TOTAL_USERS_BY_GROUP_USERS_UNIT');
        successData.groupNames = successData.groupNames.map(function(item){
          return $translate.instant(item);
        });
        successData.groupsData.sort(function(a,b) {
          return (a.groupValue > b.groupValue) ? 1 : -1;
        });
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }

  }
})();
